import React from "react";

const VisualDevFilters = ({ categories, selectedCategory, onCategoryChange }) => {
  if (!categories?.length) return null;

  return (
    <div
      className="mt-5 md:mt-7 flex flex-wrap items-center justify-center gap-3 md:gap-4 px-6"
      role="toolbar"
      aria-label="Visual development categories"
    >
      {categories.map((cat) => {
        const isActive = selectedCategory === cat.id;
        return (
          <button
            key={cat.id}
            type="button"
            onClick={() => onCategoryChange(cat.id)}
            className={[
              "min-h-[44px] px-5 md:px-7 py-2.5 text-[11px] md:text-xs font-semibold uppercase tracking-[0.2em] transition-colors duration-200",
              "border border-[#25282c] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#ffa94c]/80 focus-visible:ring-offset-2 focus-visible:ring-offset-black",
              isActive
                ? "border-[#ffa94c] text-[#ffa94c] bg-[#ffa94c]/5"
                : "text-white bg-transparent hover:border-[#ffa94c] hover:text-[#ffa94c]",
            ].join(" ")}
            aria-pressed={isActive}
          >
            {cat.label}
          </button>
        );
      })}
    </div>
  );
};

export default VisualDevFilters;
